import * as React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Text from 'antd/lib/typography/Text';
import { AgentDeliveryRequest } from '@/actions/orgSettings';

export interface DeliveryFormValues {
    url: string;
}

export const toDeliveryRequest = (values: DeliveryFormValues): AgentDeliveryRequest => ({ url: values.url.trim() });

export const DeliveryFields: React.FC = () => (
    <>
        <Form.Item
            name="url"
            label="Webhook URL"
            help="Runway sends this agent's triage issue events here."
            rules={[
                { required: true, whitespace: true, message: 'Webhook URL is required' },
                { pattern: /^https:\/\/\S+$/, message: 'URL must start with https://' },
            ]}
        >
            <Input placeholder="https://example.com/runway-webhook" />
        </Form.Item>
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            When the agent is assigned, the webhook carries <Text code>targetBranch</Text> and{' '}
            <Text code>fixBranch</Text>. Have the agent push its fix to <Text code>fixBranch</Text> and Runway opens the
            pull request. If the agent opens its own instead, put <Text code>{'runway-triage:<issue id>'}</Text> in its
            body so Runway links it to the issue.
        </Text>
    </>
);
